<script setup lang="ts">
defineOptions({ inheritAttrs: false })
defineProps<{
  open: boolean
  zindex?: '-1' | '96' | '98' | '199'
  click: None | (() => void)
}>()

const mobile = useMobile()
const t2 = useT2Base({ Close: 'Uždaryti' })
const elem = useTemplateRef('elem')
</script>

<template>
  <LazyUiMouseTextFollow v-if="!mobile" :txt="t2('Close')" :elem="elem" :open />

  <Transition enter-from-class="off" leave-to-class="off">
    <div v-if="open" v-bind="$attrs" ref="elem" :class="[$style.bg, zindex && `z${zindex}`, open && 'on']" @click="click?.()">
      <div :class="$style.bg2" />
    </div>
  </Transition>
</template>

<style module>
.bg {
  composes: global(_fixed);
  composes: global(_inset);
  z-index: -1;
  transition: opacity 500ms var(--tran2);
  backdrop-filter: blur(4px);
  filter: grayscale(10%);
}
.bg2 {
  composes: global(_w100p);
  composes: global(_h100p);
  background: rgba(0, 0, 0, 0.2) url(@/assets/noise.png);
  background-size: 134px 134px;
  opacity: 0.25;
}
.bg:global(.off) {
  opacity: 0.01;
  transition: opacity 200ms var(--tran2);
}
.bg:global(.z-1) {
  z-index: -1;
}
.bg:global(.z98) {
  z-index: 98;
}
.bg:global(.z96) {
  z-index: 96;
}
.bg:global(.z199) {
  z-index: 199;
}
</style>
